import { FileType } from '../../common';

export const DEFAULT_SIZE_LIMIT = 5000;

export const imageFileTypes = [FileType.PDF, FileType.JPG, FileType.PNG];
